import React from "react";
import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS } from "@/lib/brand";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] bg-[#0B1324]"
    >
      <div className="container-edge py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <span
                aria-hidden
                className="font-display text-[28px] leading-none tracking-[-0.04em] font-extrabold text-white"
              >
                AC
              </span>
              <span
                aria-hidden
                className="w-px h-10 bg-white/15"
              />
              <div className="leading-tight">
                <div className="font-display text-lg tracking-tight text-white">
                  {BRAND.name}
                </div>
                <div className="overline !text-[10px] mt-1">
                  {BRAND.tagline}
                </div>
              </div>
            </div>
            <p className="mt-8 max-w-md text-white/55 leading-relaxed text-[15px]">
              Premium-Coaching für Menschen, die in der Berufswelt Verantwortung
              übernehmen. Vertraulich, präzise, wirksam.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">Navigation</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace(/\W+/g, "") || "home"}`}
                    className="text-white/75 hover:text-white text-[15px] link-underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/impressum" data-testid="footer-link-impressum" className="text-white/75 hover:text-white text-[15px] link-underline">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="text-white/75 hover:text-white text-[15px] link-underline">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="overline mb-5">Kontakt</div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/80 text-[15px]">
                <MapPin size={18} className="mt-0.5 text-brand-400" strokeWidth={1.5} />
                <span>
                  {BRAND.company} — {BRAND.name}
                  <br />
                  {BRAND.address.street}
                  <br />
                  {BRAND.address.city}
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/80 text-[15px]">
                <Phone size={18} className="text-brand-400" strokeWidth={1.5} />
                <a href={BRAND.phoneHref} data-testid="footer-phone" className="link-underline">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80 text-[15px]">
                <Mail size={18} className="text-brand-400" strokeWidth={1.5} />
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="link-underline">
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[13px] text-white/45">
          <div>
            © {new Date().getFullYear()} {BRAND.company} — {BRAND.name}. Alle Rechte vorbehalten.
          </div>
          <div className="tracking-[0.18em] uppercase text-[11px] text-white/40">
            Coaching · Interim-GF · Projektmandate · Speaker
          </div>
        </div>
      </div>
    </footer>
  );
}
